import { ForkRightRounded, HealthAndSafetyRounded, VaccinesRounded } from '@mui/icons-material';
import { RouteName } from '../types/commonTypes';
import { getAppVersion } from './localStorage';

export const APPLICATION_CONFIG_URL = '/nuacare-cds-admin';
// to be changed
export const COMMON_APPLICATION_CONFIG_URL = '/nuacare-cds-admin';

export const getJsonPath = (
    path: string,
    {
        configUrl = import.meta.env.BASE_URL,
        appVersionNumber = getAppVersion(),
    } = {},
) => {
    let jsonPath = path || '';
    if (!jsonPath.startsWith('/')) {
        jsonPath = '/'.concat(jsonPath);
    }
    return `${configUrl}${jsonPath}?ver=${appVersionNumber}`;
};

export const PAGE_ROUTES: Record<RouteName, string> = {
    BASE_ROUTE: '/',
    BRANCHES: '/branches',
    CLAIMS: '/claims',
    DRUG_SCREENING: '/drug-screening',
};

export const menuIcons = {
    BRANCHES: ForkRightRounded,
    CLAIMS: HealthAndSafetyRounded,
    DRUG: VaccinesRounded,
};

export const DEFAULT_PAGE_NUMBER = 0;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25];
export const DEFAULT_DATE_PERIOD = 'PAST_7_DAYS';

export const privileges = {
};
